export const getRadioCommonStyles = (checked: boolean) => {
  // TODO: need to remove these styles once it is fixed by common component team.
  return {
    label: {
      fontSize: "14px",
      paddingInlineStart: "8px"
    },
    radio: {
      Position: "absolute",
      ...(checked && { borderWidth: "2px" })
    }
  };
};
